import React from 'react';
import { ThemeProvider } from '@material-ui/core';

import { theme } from './theme';
import { Routes } from './Routes';
import { ProvideAuth } from './Features/Authentication/ProvideAuth';
import AxiosSetting from './shared/AxiosSetting';

export default function App() {

    return (
        <ThemeProvider theme={theme}>
            <ProvideAuth>
                <AxiosSetting />
                <Routes />
            </ProvideAuth>
        </ThemeProvider>
    );
}
